import { useState } from 'react';

import { useForm } from 'react-hook-form';

import { setAuthForm, setViewerEmail } from '@/entities/viewer';

import { AUTH_API } from '@/shared/api/amplify';
import { showErrorAlert } from '@/shared/lib/showErrorAlert';
import { AuthForm } from '@/shared/types/Cognito';

import { EmailInput } from '../../components/EmailInput';
import { FormContainer } from '../../components/FormContainer';
import { GoBackLink } from '../../components/GoBackLink';
import { SubmitButton } from '../../components/SubmitButton/styled';
import { Container } from './styled';

type FormValues = {
  email: string;
};

export const ForgotPassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { control, handleSubmit, reset } = useForm<FormValues>({
    defaultValues: {
      email: '',
    },
    mode: 'onSubmit',
  });

  const onSubmit = async (input: FormValues) => {
    try {
      setIsLoading(true);

      const { email } = input;

      await AUTH_API.forgotPassword(email);

      setAuthForm(AuthForm.ChangePassword);
      setViewerEmail(email);

      reset();
    } catch (e) {
      showErrorAlert(e);
    }
    setIsLoading(false);
  };

  const switchToSigninForm = () => {
    setAuthForm(AuthForm.Signin);
  };

  return (
    <FormContainer
      title="Forgot Your Password?"
      subtitle="Enter your email address and we will send you instructions on how to reset your password."
      onSubmit={handleSubmit(onSubmit)}
    >
      <Container>
        <EmailInput control={control} isDisabled={isLoading} />

        <SubmitButton
          data-testid="forgot-password-confirm"
          disabled={isLoading}
          isLoading={isLoading}
          onClick={handleSubmit(onSubmit)}
        >
          Confirm
        </SubmitButton>
        <GoBackLink data-testid="forgot-password-sign-in" text="Back to Sign in" onClick={switchToSigninForm} />
      </Container>
    </FormContainer>
  );
};
